import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IotDeviceData } from '../models/iot/iot-device-data.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OmIotDeviceDataService extends RequestService<IotDeviceData> {
  static PATH = '/om/iotdevice/data';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmIotDeviceDataService.PATH, globalService.debugUrl);
  }
}
